<template>
  <GestionCargaMasiva/>
</template>
<script>

import {defineComponent} from "vue";
import GestionCargaMasiva from "@/views/cargamasiva/components/GestionCargaMasiva.vue";

export default defineComponent({
  components: {GestionCargaMasiva}
})
</script>
